import { useCallback, useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import useAppNavigation from '~/hooks/useAppNavigation';

export type TripPlannerChatSearchParams = {
  chatId?: string;
  userId?: string;
};

function sanitizeSearchValue(value?: string | null) {
  const trimmedValue = value?.trim();

  return trimmedValue ? trimmedValue : undefined;
}

export function useTripPlannerChatSearchParams() {
  const { push } = useAppNavigation();
  const location = useLocation();

  const searchParams = useMemo<TripPlannerChatSearchParams>(() => {
    const params = new URLSearchParams(location.search);

    return {
      chatId: sanitizeSearchValue(params.get('chatId')),
      userId: sanitizeSearchValue(params.get('userId')),
    };
  }, [location.search]);

  const updateSearchParams = useCallback(
    (nextSearchParams: TripPlannerChatSearchParams, pathname = location.pathname) => {
      const params = new URLSearchParams();

      if (nextSearchParams.chatId) {
        params.set('chatId', nextSearchParams.chatId);
      }

      if (nextSearchParams.userId) {
        params.set('userId', nextSearchParams.userId);
      }

      push({
        pathname,
        search: params.toString() ? `?${params.toString()}` : '',
      });
    },
    [push, location.pathname],
  );

  return {
    searchParams,
    updateSearchParams,
  };
}
